import { TranslateService } from '@ngx-translate/core';
import 'moment/locale/nl.js';
import { HeaderService } from 'onego-header';
import { firstValueFrom } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { AppSettingsService } from '../mtp-common/services';
import { AppStateService } from '../mtp-common/services/state';
import { configureMoment } from '../utils/moment-utils';

export function AppInitializerFactory(
    headerService: HeaderService,
    translate: TranslateService,
    appSettingsService: AppSettingsService,
    appState: AppStateService
) {
    return async (): Promise<void> => {
        await firstValueFrom(headerService.onInitialized.pipe(filter(Boolean)));

        // Load app settings
        await appSettingsService.initializeApp();

        // Set translation defaults
        translate.setDefaultLang(environment.fallbackLocale);

        environment.supportedLocales.forEach((locale) => translate.reloadLang(locale));

        return firstValueFrom(
            appState.user.distinctStream.pipe(
                switchMap((user) => {
                    const userLocale =
                        user?.profile?.language || localStorage.getItem('USER_LANGUAGE') || environment.defaultLocale;

                    configureMoment(userLocale);
                    return translate.use(userLocale);
                }),
                map((): void => undefined)
            )
        );
    };
}
